

















export default {
  name: 'ProductTileLayout',
}
